module.exports = new __parcel__URL__("Java.bb8e15f3.png").toString();